import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';
import { Breadcrumb } from '@els/els-react--breadcrumb';
import { paths } from '@AppRoutes/constants.js';
import './ConditionsBreadcrumbs.scss';

function ConditionsBreadcrumbs({ projectName }) {
  const location = useLocation();
  const isDraw = location.pathname === paths.CONDITIONS_DRAW;
  const isNavigator = location.pathname === paths.CONDITIONS;
  const isDetail = !isDraw && !isNavigator;

  const drawItem = isDraw
    ? { type: 'button', label: 'Draw' }
    : {
        type: 'link',
        linkElementProps: {
          children: 'Draw',
          href: paths.CONDITIONS_DRAW,
          routerComponent: Link,
          'data-e2e': 'breadcrumb-conditions-draw',
          className: 'c-els-color-info',
        },
      };

  const navigatorItem = isNavigator
    ? { type: 'button', label: 'My Conditions Projects' }
    : {
        type: 'link',
        linkElementProps: {
          children: 'My Conditions Projects',
          href: paths.CONDITIONS,
          routerComponent: Link,
          'data-e2e': 'breadcrumb-conditions-list',
          className: 'c-els-color-info',
        },
      };

  const items = [drawItem, navigatorItem, ...(isDetail ? [{ type: 'button', label: projectName || 'Condition project' }] : [])];

  return (
    <Breadcrumb
      className="u-els-padding-top u-els-padding-bottom u-els-padding-left-2x u-els-padding-right-2x u-els-background-color-n0 u-els-font-size-base rs-breadcrumbs"
      itemData={items}
    />
  );
}

ConditionsBreadcrumbs.propTypes = {
  projectName: PropTypes.string,
};

export default ConditionsBreadcrumbs;
